"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const translate_1 = require("components/translate");
const NotPublishedBadge = ({ t }) => {
    const separator = '\u25CF';
    return ((0, jsx_runtime_1.jsxs)("span", { className: "_d-flex _align-items-center _text-1 _text-red", children: [separator, (0, jsx_runtime_1.jsx)("span", { className: "_ml-1", children: t('content_list.not_published') })] }));
};
exports.default = (0, translate_1.translate)()(NotPublishedBadge);
